import logoimg from "../../../Assets/images/logoh.png";
import * as React from "react";
import {
  Container,
  Nav,
  Navbar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMenuContext } from "../../../StateManagement/Contexts/MenuContext";
import Button from "react-bootstrap/Button";
import PwaGuide from "../PwaGuide";
import { logoutStatic } from "../../../StateManagement/authSlice";
import { fetchData, formatNumber } from "../../../Cpanel/Components/Utilities";
import HeadLoader from "../../../Components/HeadLoader";
import { useLoad } from "../../../Hooks/useLoad";
import { unload } from "../../../StateManagement/loadingServiceSlice";
export const Header = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [sidebarMenu, setSidebarMenu] = useState([]);
  const [checkLogin, setCheckLogin] = useState(null);
  const {
    name,
    family,
    regdate: userRegDate,
    InsPay,
    grade,
  } = useSelector((state) => state.auth);
  const [coin, setCoin] = useState(0);

  const dispatch = useDispatch();
  const { selectMenuItem } = useMenuContext();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let rt = params.get("rt");

  useEffect(() => {
    if (userId < 1) {
      if (rt) {
        Cookies.set("rt", rt, { expires: 30 });
      }
    }
  }, [userId]);

  const location = useLocation();
  const load = useLoad("headerloade", true);
  useEffect(() => {
    const getBaseData = async () => {
      // load()
      const bodyFormData = new FormData();
      bodyFormData.append("guid", Cookies.get("guid"));
      await fetchData("sidebar", bodyFormData, handleSidebarAPIResponse, load);
      await fetchData("freecoin", bodyFormData, handleCoinApiResponse, load);
      // unload()
    };
    getBaseData();
    if (checkLogin === "0") {
      dispatch(logoutStatic());
      navigate("/");
    }
  }, []);

  const handleSidebarAPIResponse = (data) => {
    selectMenuItem(data?.dt);
    setSidebarMenu(data?.dt?.sort((a, b) => a.sort - b.sort));
    setUserId(data?.UserId);
  };
  const handleCoinApiResponse = (data) => {
    setCheckLogin(data?.UserId);
    setCoin(data?.totalCoin);
  };

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef();
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
          setSidebarOpen(false);
        }
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleSidebar = () => {
    setTimeout(() => {
      setSidebarOpen(!isSidebarOpen);
    });
  };

  const openSidebar = () => {
    setSidebarOpen(true);
  };
  const closeSidebar = () => {
    setSidebarOpen(false);
  };
  return (
    <header className="header mb-5">
      <div className="header-top border-bottom bg-white headersticky position-relative">
        <HeadLoader />
        <div className="header-top-container">
          <div className="row align-items-center ">
            <div className="col-lg-2   col-3 ">
              <Button
                className="btn btn-light m-2 btn-sm  "
                onClick={isSidebarOpen ? closeSidebar : openSidebar}
                ref={menuRef}
              >
                <FontAwesomeIcon
                  icon={`${!isSidebarOpen ? "bars" : "close"}`}
                  className="bars-icon"
                />
              </Button>
              <div
                className={`sidebar ${isSidebarOpen ? "open" : ""}`}
                ref={sidebarRef}
              >
                <div id="sidebarMenu" className="overflow-y-auto">
                  <ul dir="rtl" className="sidebarMenuInner ">
                    {sidebarMenu?.map((menuItem) => {
                      return (
                        <li key={menuItem.id}>
                          <Link
                            to={`/page/${menuItem.id}/${
                              menuItem.title.split("|")[0]
                            }`}
                          >
                            {menuItem.title.split("|")[1]}
                          </Link>
                        </li>
                      );
                    })}
                    <li>
                      <Link to={`/referral`}>کسب درآمد</Link>
                    </li>
                    <li className="d-flex">
                      <PwaGuide size={27} />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-8 m-auto col-5 text-center">
              <Link to="/">
                <img
                  className="m-auto maxh-40 mt-2 mb-2 logo"
                  alt="logo"
                  src={logoimg}
                />
              </Link>
            </div>
            <div className="col-lg-2 col-4 ">
              <div className="d-flex flex-row-reverse align-items-center justify-content-center gap-2 ">
                <div>
                  <Link to={"/MyCoins"} className=" text-decoration-none">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip>
                          {
                            "سکه درون برنامه ای می باشد که عنوان پاداش با فعالیت های درون برنامه تخصیص می شود می توانید به وسیله آن از تمامی امکانات سیستم استفاده نمایید"
                          }
                        </Tooltip>
                      }
                    >
                      <Link
                        to={"/MyCoins"}
                        state={"/home"}
                        className="text-decoration-none text-warning header-icon-box d-flex gap-1"
                      >
                        <FontAwesomeIcon icon="coins" className="header-icon" />
                        <span>{formatNumber(coin)}</span>
                        پارسی
                      </Link>
                    </OverlayTrigger>
                  </Link>
                </div>
                <div className="message-icon">
                  <Link to={"/messageBox"}>
                    <FontAwesomeIcon
                      icon={"bell"}
                      className="header-icon text-danger mt-1"
                    />
                     <span className="message-badge">{formatNumber(2)}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
